import { j as s, c as v } from "../../utils-BdNIfrGQ.js";
import { D as C, a as b, b as y, c as z, d as k, e as w, f as V, g as N, h as F, i as m } from "../../dialog-C3hgj4md.js";
import { a as e } from "../../Button-CzIiGCVn.js";
import "../../theme/provider/ThemeProvider.mjs";
import "react";
import "../../Div-spVpsZsH.js";
import "../../Div.skeleton-DLnqOZrU.js";
import "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import "../../ScrollToGrid-6uyEoyhk.js";
import "../../NavLink-D9Qfouy1.js";
import "../../HamburgerMenu-Bi4wrZqX.js";
import "../avatar/Avatar.mjs";
import { u as L } from "../../ResponsiveProvider-C06ERneB.js";
import "../../toast-DrFMmSLk.js";
import "react-dom";
import "../../Button.skeleton-D0Onk1OP.js";
import { c } from "../../index-Di82Y7n3.js";
const R = c("", {
  variants: {
    size: {
      default: "sm:max-w-lg",
      lg: "sm:max-w-3xl"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), B = c("gap-3", {
  variants: {
    footerLayout: {
      stacked: "",
      inline: "flex-row justify-end"
    }
  },
  defaultVariants: {
    footerLayout: "stacked"
  }
}), Z = ({
  trigger: r,
  dialogTitle: i,
  description: o,
  dialogHeaderContent: d,
  children: p,
  footer: t,
  closeButtonText: l,
  onInteractOutside: x,
  container: h,
  size: u,
  footerLayout: f,
  ...j
}) => {
  const { isMobile: g } = L(), n = g ? "default" : "sm";
  return /* @__PURE__ */ s.jsxs(C, { ...j, children: [
    r && /* @__PURE__ */ s.jsx(b, { asChild: !0, children: /* @__PURE__ */ s.jsx(e, { ...r, children: r.children }) }),
    /* @__PURE__ */ s.jsxs(y, { container: h, children: [
      /* @__PURE__ */ s.jsx(z, {}),
      /* @__PURE__ */ s.jsxs(
        k,
        {
          className: v(R({ size: u }), "max-h-[calc(100%-2rem)] overflow-y-auto"),
          "aria-describedby": i?.text,
          onInteractOutside: x,
          children: [
            /* @__PURE__ */ s.jsxs(w, { children: [
              i && /* @__PURE__ */ s.jsxs(V, { className: "flex items-center", children: [
                i.icon,
                i.text
              ] }),
              o && /* @__PURE__ */ s.jsx(N, { children: o }),
              d
            ] }),
            p,
            t && /* @__PURE__ */ s.jsxs(F, { className: B({ footerLayout: f }), children: [
              l && /* @__PURE__ */ s.jsx(m, { asChild: !0, children: /* @__PURE__ */ s.jsx(e, { variant: "outline", size: n, children: l }) }),
              t.map((a, D) => /* @__PURE__ */ s.jsx(m, { asChild: !0, children: /* @__PURE__ */ s.jsx(
                e,
                {
                  onClick: a.onClick,
                  variant: a.variant,
                  size: n,
                  spacing: a.spacing,
                  disabled: a.disabled,
                  children: a.children
                }
              ) }, D))
            ] })
          ]
        }
      )
    ] })
  ] });
};
export {
  Z as default
};
